import { GalenErrorKeys } from 'src/models/GalenData/GalenError.model';

const KNOWN_KEYS: ReadonlySet<string> = new Set(Object.values(GalenErrorKeys));

// The body this reads also carries patient data, so only exact enum members are returned —
// nothing else can escape through the caller.
export const galenErrorKey = (data: unknown): string | undefined => {
  if (typeof data !== 'string') return undefined;
  return data
    .toLowerCase()
    .split(/[^a-z0-9-]+/)
    .find((token) => KNOWN_KEYS.has(token));
};
